import { toHex, toVersionInt } from "@covvi/common-functions"

export const stringVersionToInt = (version: string) => {
  const major = toHex(parseInt(version.split(".")[0]))
  const mid = toHex(parseInt(version.split(".")[1]))
  const minor = toHex(parseInt(version.split(".")[2]))

  return toVersionInt(major + mid + minor)
}
